import type { Template } from "@/types";

export const PO_05_H4_V1: Template[] = [
{
    id: "po-05-h4v1-01",
    name: "PO 01 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 56, y: 259, width: 456, height: 337, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 626, y: 213, width: 186, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 626, y: 359, width: 186, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 626, y: 504, width: 186, height: 137, rotation: 0, imageRotation: 0 },
            { id: "5", x: 820, y: 213, width: 260, height: 428, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-05-h4v1-02",
    name: "PO 02 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_02.png",
    size: [1136, 854],
    style: {},
    slots: [       
        { id: "1", x: 172, y: 88, width: 224, height: 164, rotation: 0, imageRotation: 0 },
        { id: "2", x: 172, y: 260, width: 224, height: 164, rotation: 0, imageRotation: 0 },
        { id: "3", x: 172, y: 432, width: 224, height: 163, rotation: 0, imageRotation: 0 },
        { id: "4", x: 172, y: 603, width: 224, height: 163, rotation: 0, imageRotation: 0 },
        { id: "5", x: 655, y: 88, width: 394, height: 678, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h4v1-03",
    name: "PO 03 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_03.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 31, y: 216, width: 277, height: 208, rotation: 0, imageRotation: 0 },
        { id: "2", x: 31, y: 432, width: 277, height: 208, rotation: 0, imageRotation: 0 },
        { id: "3", x: 316, y: 0, width: 504, height: 854, rotation: 0, imageRotation: 0 },
        { id: "4", x: 828, y: 216, width: 277, height: 208, rotation: 0, imageRotation: 0 },
        { id: "5", x: 828, y: 432, width: 277, height: 208, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h4v1-04",
    name: "PO 04 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 25, y: 163, width: 523, height: 392, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 25, y: 563, width: 169, height: 129, rotation: 0, imageRotation: 0 },
        { id: "3", x: 202, y: 563, width: 169, height: 129, rotation: 0, imageRotation: 0 },
        { id: "4", x: 379, y: 563, width: 169, height: 129, rotation: 0, imageRotation: 0 },
        { id: "5", x: 693, y: 163, width: 319, height: 529, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h4v1-05",
    name: "PO 05 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_05.png",
    size: [1136, 854],
    style: {},
    slots: [       
        { id: "1", x: 29, y: 333, width: 254, height: 189, rotation: 0, imageRotation: 0 },
        { id: "2", x: 291, y: 333, width: 254, height: 189, rotation: 0, imageRotation: 0 },
        { id: "3", x: 163, y: 136, width: 255, height: 189, rotation: 0, imageRotation: 0 },
        { id: "4", x: 163, y: 530, width: 255, height: 189, rotation: 0, imageRotation: 0 },
        { id: "5", x: 679, y: 136, width: 346, height: 583, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h4v1-06",
    name: "PO 06 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_06.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 0, y: 354, width: 190, height: 145, rotation: 0, imageRotation: 0 },
        { id: "2", x: 198, y: 354, width: 189, height: 145, rotation: 0, imageRotation: 0 },
        { id: "3", x: 395, y: 135, width: 346, height: 583, rotation: 0, imageRotation: 0 },
        { id: "4", x: 749, y: 354, width: 190, height: 145, rotation: 0, imageRotation: 0 },
        { id: "5", x: 947, y: 354, width: 189, height: 145, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h4v1-07",
    name: "PO 07 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 0, width: 506, height: 854, rotation: 0, imageRotation: 0 },
        { id: "2", x: 625, y: 194, width: 453, height: 338, rotation: 0, imageRotation: 0 },
        { id: "3", x: 625, y: 540, width: 146, height: 120, rotation: 0, imageRotation: 0 },
        { id: "4", x: 779, y: 540, width: 146, height: 120, rotation: 0, imageRotation: 0 },
        { id: "5", x: 933, y: 540, width: 145, height: 120, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h4v1-08",
    name: "PO 08 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 69, y: 66, width: 429, height: 722, rotation: 0, imageRotation: 0 },
        { id: "2", x: 614, y: 249, width: 235, height: 174, rotation: 0, imageRotation: 0 },
        { id: "3", x: 614, y: 431, width: 235, height: 174, rotation: 0, imageRotation: 0 },
        { id: "4", x: 857, y: 249, width: 234, height: 174, rotation: 0, imageRotation: 0 },
        { id: "5", x: 857, y: 431, width: 234, height: 174, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h4v1-09",
    name: "PO 09 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 223, width: 530, height: 409, rotation: 0, imageRotation: 0 },
        { id: "2", x: 538, y: 223, width: 347, height: 272, rotation: 0, imageRotation: 0 },       
        { id: "3", x: 538, y: 503, width: 170, height: 129, rotation: 0, imageRotation: 0 },
        { id: "4", x: 716, y: 503, width: 169, height: 129, rotation: 0, imageRotation: 0 },
        { id: "5", x: 893, y: 223, width: 243, height: 409, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h4v1-10",
    name: "PO 10 - H4V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h4_v1_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 219, width: 166, height: 131, rotation: 0, imageRotation: 0 },
        { id: "2", x: 174, y: 219, width: 165, height: 131, rotation: 0, imageRotation: 0 },
        { id: "3", x: 0, y: 358, width: 339, height: 277, rotation: 0, imageRotation: 0 },
        { id: "4", x: 347, y: 219, width: 538, height: 416, rotation: 0, imageRotation: 0 },
        { id: "5", x: 893, y: 219, width: 244, height: 416, rotation: 0, imageRotation: 0 }      
    ],
}
];